"use strict";
exports.__esModule = true;
exports.checkFirstAndLastName = exports.checkLastName = exports.checkFirstName = void 0;
var opaque_types_1 = require("@shef/opaque-types");
var Either_1 = require("fp-ts/Either");
/**
 * All of the characters in a name have to match one of the following:
 * \s          # white space
 * \p{L}       # Unicode letter, or
 * \p{Mn}      # Unicode accents, or
 * \p{Pd}      # Unicode hyphens, or
 * '           # single quote, or
 * \u2019      # single quote (alternative)
 * &           # Allow the & (e.g. for Tim & Tom)
 * .           # Period character (e.g. for Dean Sr.)
 * \d          # 0-9 (for seed data... or maybe if X Æ A-12 Musk ever signs up?)
 **/
var UNSUPPORTED_NAME_REGEX = /[^a-z\s\p{L}\p{Mn}\p{Pd}'\u2019&.\d]/u;
var checkNamePart = function (namePart, part) {
    var sanitized = namePart === null || namePart === void 0 ? void 0 : namePart.trim();
    if (!sanitized) {
        return (0, Either_1.left)("Please enter a " + part + " name");
    }
    if (UNSUPPORTED_NAME_REGEX.test(sanitized)) {
        return (0, Either_1.left)("Invalid character in " + part + " name");
    }
    return (0, Either_1.right)((0, opaque_types_1.makeOpaque)(sanitized));
};
var checkFirstName = function (name) {
    return checkNamePart(name, 'first');
};
exports.checkFirstName = checkFirstName;
var checkLastName = function (name) {
    return checkNamePart(name, 'last');
};
exports.checkLastName = checkLastName;
var checkFirstAndLastName = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    var firstNameCheck = (0, exports.checkFirstName)(firstName);
    var lastNameCheck = (0, exports.checkLastName)(lastName);
    if (!(firstName === null || firstName === void 0 ? void 0 : firstName.trim()) && !(lastName === null || lastName === void 0 ? void 0 : lastName.trim())) {
        return (0, Either_1.left)('Please enter a first and last name');
    }
    if ((0, Either_1.isLeft)(firstNameCheck)) {
        return (0, Either_1.left)(firstNameCheck.left);
    }
    if ((0, Either_1.isLeft)(lastNameCheck)) {
        return (0, Either_1.left)(lastNameCheck.left);
    }
    return (0, Either_1.right)((0, opaque_types_1.makeOpaque)({ firstName: firstNameCheck.right, lastName: lastNameCheck.right }));
};
exports.checkFirstAndLastName = checkFirstAndLastName;
//# sourceMappingURL=checkName.js.map